import React, { useEffect, useState } from "react";
import TextBox from "../../../Common/components/TextBox";
import Label from "../../../Common/components/Label";
import { DEFAULT_ATTRIBUTE_CONSTRAINT_VALUE } from "../constants";

const EditAttributeConstraint = ({
  attributeConstraint,
  setAttributeConstraint,
}) => {
  const [category, setCategory] = useState(
    attributeConstraint || DEFAULT_ATTRIBUTE_CONSTRAINT_VALUE
  );

  useEffect(() => {
    setAttributeConstraint(category);
  }, [category]);

  const handleChange = (e) => {
    //const [id, value] = e.target;
    const id = e.target.id;
    const value = e.target.value;
    setCategory((currentCategory) => {
      return {
        ...currentCategory,
        [id]: value,
      };
    });
  };

  const handleCheckBoxChange = (e, checked) => {
    const id = e.target.id;
    setCategory((currentCategory) => {
      if (id === "validation") {
        return {
          ...currentCategory,
          validation: checked,
          allowed_user_defined_values: !checked,
        };
      }
      if (id === "allowed_user_defined_values") {
        return {
          ...currentCategory,
          allowed_user_defined_values: checked,
          validation: !checked,
        };
      }
      return {
        ...currentCategory,
        [id]: checked,
      };
    });
  };

  return (
    <>
      <div className="p-3" style={{ border: "1px solid #d6d8d9" }}>
        <div className="container overflow-hidden">
          <div className="row g-3">
            <div className="col-md-3">
              <Label message="Datatype" htmlFor="datatype" fontSize={0.8} />
              <select
                id="datatype"
                onChange={handleChange}
                className="form-select form-select-sm border-1"
                style={{
                  fontWeight: "600",
                  fontSize: "0.8rem",
                  borderColor: "#c9c9cf",
                }}
                value={category && category.datatype && category.datatype}
              >
                <option>INTEGER</option>
                <option>TEXT</option>
                <option>DECIMAL</option>
                {/* <option>DATE TIME</option> */}
                <option>BOOLEAN</option>
              </select>
            </div>
            <div className="col-md-9"></div>

            <div className="form-check form-switch col-md-12 ms-2 mt-5">
              <input
                className="form-check-input"
                type="checkbox"
                // disabled={true}
                onChange={(e) => handleCheckBoxChange(e, !category.validation)}
                checked={category && category.validation && category.validation}
                id="validation"
              />
              {/* <label className="form-check-label" htmlFor="validation">
            Validation
          </label> */}
              <Label fontSize={0.8} message="Validation" htmlFor="validation" />
            </div>
            <div className="col-md-2 mt-1">
              {/* <label htmlFor="validation_type" className="form-label">
            Validation Type
          </label> */}
              <Label
                fontSize={0.8}
                message="Validation Type"
                htmlFor="validation_type"
              />
              <select
                id="validation_type"
                className="form-select form-select-sm border-1"
                onChange={handleChange}
                disabled={category && !category.validation}
                style={{
                  fontWeight: "600",
                  fontSize: "0.8rem",
                  borderColor: "#c9c9cf",
                }}
                defaultValue={
                  category &&
                  category.validation_type &&
                  category.validation_type
                }
                value={
                  category &&
                  category.validation_type &&
                  category.validation_type
                }
              >
                <option>LOV</option>
                {/* <option>NOTE</option>
            <option>STRICT</option>
            <option>VALUE</option>
            <option>LIST</option>
            <option>RANGE</option>
            <option>STRING</option> */}
              </select>
            </div>
            <div className="col-md-5 mt-1">
              {/* <label htmlFor="validation_range" className="form-label">
            Validation Range
          </label> */}
              <Label
                fontSize={0.8}
                message="Validation Range"
                htmlFor="validation_range"
              />
              {/* <input
            placeholder="e.g 1-5"
            type="number"
            onChange={handleChange}
            value={category.validation_range}
            className="form-control"
            id="validation_range"
          /> */}
              <TextBox
                type="number"
                disabled={true}
                value={
                  category &&
                  category.validation_range &&
                  category.validation_range
                }
                onChange={handleChange}
                placeholder="e.g 1-5"
                id="validation_range"
              />
            </div>
            <div className="col-md-5 mt-1">
              {/* <label
            htmlFor="validation_type_extra_criteria"
            className="form-label"
          >
            Validation Type Extra Criteria
          </label> */}
              <Label
                fontSize={0.8}
                message="Validation Type Extra Criteria"
                htmlFor="validation_type_extra_criteria"
              />
              <TextBox
                type="text"
                disabled={true}
                value={
                  category &&
                  category.validation_type_extra_criteria &&
                  category.validation_type_extra_criteria
                }
                onChange={handleChange}
                placeholder="Enter validation type extra criteria"
                id="validation_type_extra_criteria"
              />
              {/* <input
            placeholder="Enter validation type extra criteria"
            type="text"
            onChange={handleChange}
            value={category.validation_type_extra_criteria}
            className="form-control"
            id="validation_type_extra_criteria"
          /> */}
            </div>
            <div className="form-check form-switch col-md-12 ms-2 mt-5">
              <input
                className="form-check-input"
                type="checkbox"
                disabled={true}
                onChange={(e) =>
                  handleCheckBoxChange(e, !category.validation_input_message)
                }
                checked={
                  category &&
                  category.validation_input_message &&
                  category.validation_input_message
                }
                id="validation_input_message"
              />
              {/* <label
            className="form-check-label"
            htmlFor="validation_input_message"
          >
            Validation Input Message
          </label> */}
              <Label
                fontSize={0.8}
                message="Validation Input Message"
                htmlFor="validation_input_message"
              />
            </div>
            <div className="col-md-6 mt-1">
              {/* <label
            htmlFor="validation_input_message_title"
            className="form-label"
          >
            Validation Input Message Title
          </label> */}
              <Label
                fontSize={0.8}
                message="Title"
                htmlFor="validation_input_message_title"
              />
              <TextBox
                type="text"
                disabled={true}
                value={
                  category &&
                  category.validation_input_message_title &&
                  category.validation_input_message_title
                }
                onChange={handleChange}
                placeholder="e.g Pro tip"
                id="validation_input_message_title"
              />
              {/* <input
            placeholder="e.g Pro tip"
            type="text"
            onChange={handleChange}
            value={category.validation_input_message_title}
            className="form-control"
            id="validation_input_message_title"
          /> */}
            </div>
            <div className="col-md-6 mt-1">
              {/* <label htmlFor="validation_input_message_body" className="form-label">
            Validation Input Message Body
          </label> */}
              <Label
                fontSize={0.8}
                message="Message"
                htmlFor="validation_input_message_body"
              />
              {/* <input
            placeholder="e.g Validate before you save"
            type="text"
            onChange={handleChange}
            value={category.validation_input_message_body}
            className="form-control"
            id="validation_input_message_body"
          /> */}
              <TextBox
                type="text"
                disabled={true}
                value={
                  category &&
                  category.validation_input_message_body &&
                  category.validation_input_message_body
                }
                onChange={handleChange}
                placeholder="e.g Validate before you save"
                id="validation_input_message_body"
              />
            </div>
            <div className="form-check form-switch col-md-12 ms-2 mt-5">
              <input
                className="form-check-input"
                type="checkbox"
                disabled={true}
                onChange={(e) =>
                  handleCheckBoxChange(e, !category.validation_error_alert)
                }
                checked={
                  category &&
                  category.validation_error_alert &&
                  category.validation_error_alert
                }
                id="validation_error_alert"
              />
              {/* <label className="form-check-label" for="validation_error_alert">
            Validation Error Alert
          </label> */}
              <Label
                fontSize={0.8}
                message="Validation Error Alert"
                htmlFor="validation_error_alert"
              />
            </div>
            <div className="col-md-2 mt-1">
              {/* <label htmlFor="validation_error_alert_style" className="form-label">
            Validation Error Alert Style
          </label> */}
              <Label
                fontSize={0.8}
                message="Style"
                htmlFor="validation_error_alert_style"
              />
              <select
                id="validation_error_alert_style"
                className="form-select form-select-sm"
                disabled={true}
                style={{ fontWeight: "600", fontSize: "0.8rem" }}
                onChange={handleChange}
                value={
                  category &&
                  category.validation_error_alert_style &&
                  category.validation_error_alert_style
                }
              >
                <option>STOP</option>
                <option>WARNING</option>
                <option>INFO</option>
              </select>
            </div>
            <div className="col-md-5 mt-1">
              {/* <label htmlFor="validation_error_alert_title" className="form-label">
            Validation Error Alert Title
          </label> */}
              <Label
                fontSize={0.8}
                message="Title"
                htmlFor="validation_error_alert_title"
              />
              {/* <input
            placeholder="e.g Danger. Will Robinson!"
            type="text"
            onChange={handleChange}
            value={category.validation_error_alert_title}
            className="form-control"
            id="validation_error_alert_title"
          /> */}
              <TextBox
                type="text"
                disabled={true}
                value={
                  category &&
                  category.validation_error_alert_title &&
                  category.validation_error_alert_title
                }
                onChange={handleChange}
                placeholder="e.g Danger. Will Robinson!"
                id="validation_error_alert_title"
              />
            </div>
            <div className="col-md-5 mt-1">
              {/* <label htmlFor="validation_error_alert_body" className="form-label">
            Validation Error Alert Body
          </label> */}
              <Label
                fontSize={0.8}
                message="Message"
                htmlFor="validation_error_alert_body"
              />
              <TextBox
                type="text"
                disabled={true}
                value={
                  category &&
                  category.validation_error_alert_body &&
                  category.validation_error_alert_body
                }
                onChange={handleChange}
                placeholder="e.g This doesn't seem like the right kind of information"
                id="validation_error_alert_body"
              />
              {/* <input
            placeholder="e.g This doesn't seem like the right kind of information"
            type="text"
            onChange={handleChange}
            value={category.validation_error_alert_body}
            className="form-control"
            id="validation_error_alert_body"
          /> */}
            </div>
            <div className="form-check form-switch col-md-12 ms-2 mt-5">
              <input
                className="form-check-input"
                type="checkbox"
                onChange={(e) => handleCheckBoxChange(e, !category.multiselect)}
                checked={
                  category && category.multiselect && category.multiselect
                }
                id="multiselect"
              />
              {/* <label className="form-check-label" htmlFor="multiselect">
            Multiselect
          </label> */}
              <Label
                fontSize={0.8}
                message="Multiselect"
                htmlFor="multiselect"
              />
            </div>
            <div className="col-md-6 mt-1">
              {/* <label htmlFor="multiselect_number" className="form-label">
            Multiselect Number
          </label> */}
              <Label
                fontSize={0.8}
                message="Number"
                htmlFor="multiselect_number"
              />
              <TextBox
                type="number"
                disabled={true}
                value={
                  category &&
                  category.multiselect_number &&
                  category.multiselect_number
                }
                onChange={handleChange}
                placeholder="e.g 4"
                id="multiselect_number"
              />
              {/* <input
            value={category.multiselect_number}
            type="number"
            onChange={handleChange}
            className="form-control"
            id="multiselect_number"
          /> */}
            </div>
            <div className="col-md-6 mt-1">
              {/* <label htmlFor="multiselect_output_range" className="form-label">
            Multiselect Output Range
          </label> */}
              <Label
                fontSize={0.8}
                message="Output Range"
                htmlFor="multiselect_output_range"
              />
              <TextBox
                type="text"
                disabled={true}
                value={
                  category &&
                  category.multiselect_output_range &&
                  category.multiselect_output_range
                }
                onChange={handleChange}
                placeholder="e.g 1-4"
                id="multiselect_output_range"
              />
              {/* <input
            placeholder="e.g 1-5"
            type="text"
            onChange={handleChange}
            value={category.multiselect_output_range}
            className="form-control"
            id="multiselect_output_range"
          /> */}
            </div>
            <div className="form-check form-switch col-md-12 mt-5 ms-2">
              <input
                className="form-check-input"
                disabled={true}
                checked={
                  category &&
                  category.attr_inheritance &&
                  category.attr_inheritance
                }
                type="checkbox"
                onChange={(e) =>
                  handleCheckBoxChange(e, !category.attr_inheritance)
                }
                id="attr_inheritance"
              />
              {/* <label className="form-check-label" htmlFor="attr_inheritance">
            Attribute Inheritance
          </label> */}
              <Label
                fontSize={0.8}
                message="Attribute Inheritance"
                htmlFor="attr_inheritance"
              />
            </div>
            <div className="col-md-4 mt-2">
              {/* <label htmlFor="child_attr" className="form-label">
            Child Attribute
          </label> */}
              <Label
                fontSize={0.8}
                message="Child Attribute"
                htmlFor="child_attr"
              />

              <TextBox
                type="text"
                disabled={true}
                value={category && category.child_attr && category.child_attr}
                onChange={handleChange}
                placeholder="None Entered"
                id="child_attr"
              />
              {/* <input
            value={category.child_attr}
            type="text"
            onChange={handleChange}
            className="form-control"
            id="child_attr"
          /> */}
            </div>
            <div className="col-md-4 mt-2">
              {/* <label htmlFor="allowed_chars" className="form-label">
            Allowed Chars
          </label> */}
              <Label
                fontSize={0.8}
                message="Allowed Characters"
                htmlFor="allowed_chars"
              />
              <TextBox
                type="text"
                disabled={true}
                value={
                  category && category.allowed_chars && category.allowed_chars
                }
                onChange={handleChange}
                placeholder="None Entered"
                id="allowed_chars"
              />
              {/* <input
            type="text"
            onChange={handleChange}
            value={category.allowed_chars}
            className="form-control"
            id="allowed_chars"
          /> */}
            </div>
            <div className="col-md-4 mt-2">
              {/* <label htmlFor="prohibited_chars" className="form-label">
            Prohibited Chars
          </label> */}
              <Label
                fontSize={0.8}
                message="Prohibited Characters"
                htmlFor="prohibited_chars"
              />
              <TextBox
                type="text"
                disabled={true}
                value={
                  category &&
                  category.prohibited_chars &&
                  category.prohibited_chars
                }
                onChange={handleChange}
                placeholder="None Entered"
                id="prohibited_chars"
              />
              {/* <input
            type="text"
            onChange={handleChange}
            value={category.prohibited_chars}
            className="form-control"
            id="prohibited_chars"
          /> */}
            </div>
            <div className="form-check form-switch col-md-12 ms-2 mt-5">
              <input
                className="form-check-input"
                type="checkbox"
                id="allowed_user_defined_values"
                checked={
                  category &&
                  category.allowed_user_defined_values &&
                  category.allowed_user_defined_values
                }
                onChange={(e) =>
                  handleCheckBoxChange(e, !category.allowed_user_defined_values)
                }
              />
              <Label
                fontSize={0.8}
                message="Allowed User Defined Values"
                htmlFor="allowed_user_defined_values"
              />
              {/* <label
            className="form-check-label"
            htmlFor="allowed_user_defined_values"
          >
            Allowed User Defined Values
          </label> */}
            </div>
            <div className="col-md-6">
              {/* <label htmlFor="extra_criteria_value1" className="form-label">
            Validation Type Extra Criteria 1
          </label> */}
              <Label
                fontSize={0.8}
                message="Extra Criteria Value 1"
                htmlFor="extra_criteria_value1"
              />
              <TextBox
                type="text"
                disabled={true}
                value={
                  category &&
                  category.extra_criteria_value1 &&
                  category.extra_criteria_value1
                }
                onChange={handleChange}
                placeholder="None Entered"
                id="extra_criteria_value1"
              />
              {/* <input
            placeholder="Enter validation type extra criteria value 1"
            type="text"
            onChange={handleChange}
            value={category.extra_criteria_value1}
            className="form-control"
            id="extra_criteria_value1"
          /> */}
            </div>
            <div className="col-md-6">
              {/* <label htmlFor="extra_criteria_value2" className="form-label">
            Validation Type Extra Extra Criteria 2
          </label> */}
              <Label
                fontSize={0.8}
                message="Extra Criteria Value 2"
                htmlFor="extra_criteria_value2"
              />
              <TextBox
                type="text"
                disabled={true}
                value={
                  category &&
                  category.extra_criteria_value2 &&
                  category.extra_criteria_value2
                }
                onChange={handleChange}
                placeholder="None Entered"
                id="extra_criteria_value2"
              />
              {/* <input
            placeholder="Enter validation type extra criteria value 2"
            type="text"
            onChange={handleChange}
            value={category.extra_criteria_value2}
            className="form-control"
            id="extra_criteria_value2"
          /> */}
            </div>

            <div className="col-md-6 mt-2">
              {/* <label htmlFor="special_formatting" className="form-label">
            Special Formatting
          </label> */}
              <Label
                fontSize={0.8}
                message="Special Formatting"
                htmlFor="special_formatting"
              />
              {/* <label htmlFor="special_formatting" className="form-label">
            Special Formatting
          </label> */}
              <TextBox
                type="text"
                disabled={true}
                value={
                  category &&
                  category.special_formatting &&
                  category.special_formatting
                }
                onChange={handleChange}
                placeholder="None Entered"
                id="special_formatting"
              />
              {/* <input
            type="text"
            onChange={handleChange}
            value={category.special_formatting}
            className="form-control"
            id="special_formatting"
          /> */}
            </div>

            {/* <div className="col-md-4">
          <label htmlFor="column_order" className="form-label">
            Column Order
          </label>
          <input
            value={category.column_order}
            type="number"
            onChange={handleChange}
            className="form-control"
            id="column_order"
          />
        </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default EditAttributeConstraint;
